import axios from 'axios';
import base64 from 'base-64';
import { alertType, e3 } from '../utils/utils';
import { loadCookie } from '../hooks/useCookieData';

const API_URL = process.env.REACT_APP_PROXY;
const APP_TYPE = process.env.REACT_APP_TYPE;

const axiosRequestConfig = {
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json; charset=utf-8'
    },
    responseType: 'json',
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN'
};

const axiosInstance = axios.create(axiosRequestConfig);

export const DataPackage = {
    init: () => {
        let dataPackage = {};
        dataPackage.Token = '';
        dataPackage.JsonData = '';
        dataPackage.ErrorMessage = '';
        dataPackage.ProgramId = '';
        dataPackage.MethodName = '';
        dataPackage.KeyValues = [];
        dataPackage.Division = '';
        return dataPackage;
    },
    InitSystemDataPackage: () => {
        let dataPackage = DataPackage.init();
        dataPackage.AssemblyName = 'E3.COM.SYS.BIZ.dll';
        dataPackage.Namespace = 'E3.COM.SYS.BIZ';
        dataPackage.ClassName = 'SYSTEM';
        return dataPackage;
    },
    create: (programid, methodname) => {
        let dataPackage = DataPackage.init();
        dataPackage.ProgramId = programid;
        dataPackage.MethodName = methodname;
        return dataPackage;
    },
    NewKeyValue: (key, value) => {
        let keyValue = {};
        keyValue.Key = key;
        keyValue.Value = value;
        return keyValue;
    },
    GetParam4Plant: () => {
        let m = {};
        m.Key = 'PLT_ID';
        m.Value = DataPackage.GetPlantId();
        return m;
    },
    GetPlantId: () => {
        const tmp = window.sessionStorage.getItem('loginSign');
        const ret = tmp && tmp.length > 0 ? JSON.parse(e3.base64Decode(tmp.toString())) : undefined;
        return ret.PLT_ID || '';
    }
};

const ISOAxios = {
    CreateInstance: (
        baseUrl,
        headers = { 'Content-Type': 'application/json; charset=utf-8' },
        responseType = 'json'
    ) => {
        const config = {
            baseURL: baseUrl,
            headers: headers,
            responseType: responseType,
            xsrfCookieName: 'XSRF-TOKEN',
            xsrfHeaderName: 'X-XSRF-TOKEN'
        };
        return axios.create(config);
    },
    SetToken: (value) => {
        window.sessionStorage.setItem('Token', value);
    },
    GetToken: () => {
        const tmp = window.sessionStorage.getItem('Token');
        const ret = tmp && tmp.length > 0 ? tmp.toString() : undefined;
        return ret;
    },
    Login: async (params) => {
        try {
            const result = await axiosInstance.post('/login', JSON.stringify(params));
            return typeof result.data === 'string' ? JSON.parse(result.data) : result.data;
        } catch (err) {
            throw new Error(err);
        }
    },
    Execute: async (params) => {
        try {
            e3.ui.showLoading();

            params.Token = ISOAxios.GetToken();
            const result = await axiosInstance.post('/execute', JSON.stringify(params));
            const result_data = typeof result.data === 'string' ? JSON.parse(result.data) : result.data;

            e3.ui.hideLoading();
            return result_data;  
                    
        } catch (err) {
            e3.ui.hideLoading();
            throw new Error(err);
        }
    },
    RegistGuest: async (params) => {
        try {
            e3.ui.showLoading();
            const result = await axiosInstance.post('/RegistGuest', JSON.stringify(params));
            const responseData = typeof result.data === 'string' ? JSON.parse(result.data) : result.data;
            return responseData;
        } catch (err) {
            throw new Error(err);
        } finally {
            e3.ui.hideLoading();
        }
    },
    RequestCertificationCode: async (params) => {
        try {
            e3.ui.showLoading();
            const result = await axiosInstance.post('/RequestCertificationCode', JSON.stringify(params));
            const responseData = typeof result.data === 'string' ? JSON.parse(result.data) : result.data;
            return responseData;
        } catch (err) {
            throw new Error(err);
        } finally {
            e3.ui.hideLoading();
        }
    },
    GetPlantId: () => {
        const tmp = window.sessionStorage.getItem('loginSign');
        const ret = tmp && tmp.length > 0 ? JSON.parse(e3.base64Decode(tmp.toString())) : undefined;
        return ret.PLT_ID || '';
    },
    GetMngList: async (params) => {
        try {
            e3.ui.showLoading();
            const result = await axiosInstance.post('/GetMngList', JSON.stringify(params));
            const responseData = typeof result.data === 'string' ? JSON.parse(result.data) : result.data;
            return responseData;
        } catch (err) {
            throw new Error(err);
        } finally {
            e3.ui.hideLoading();
        }
    },
    GetCmpList: async (params) => {
        try {
            e3.ui.showLoading();
            const result = await axiosInstance.post('/GetCmpList', JSON.stringify(params));
            const responseData = typeof result.data === 'string' ? JSON.parse(result.data) : result.data;
            return responseData;
        } catch (err) {
            throw new Error(err);
        } finally {
            e3.ui.hideLoading();
        }
    },
    InsertCmp: async (params) => {
        try {
            e3.ui.showLoading();
            const result = await axiosInstance.post('/InsertCmp', JSON.stringify(params));
            const responseData = typeof result.data === 'string' ? JSON.parse(result.data) : result.data;
            return responseData;
        } catch (err) {
            throw new Error(err);
        } finally {
            e3.ui.hideLoading();
        }
    },
    GetCarList: async (params) => {
        try {
            e3.ui.showLoading();
            const result = await axiosInstance.post('/GetCarList', JSON.stringify(params));
            const responseData = typeof result.data === 'string' ? JSON.parse(result.data) : result.data;
            return responseData;
        } catch (err) {
            throw new Error(err);
        } finally {
            e3.ui.hideLoading();
        }
    },
    GetUserInfo: async (params) => {
        try {
            e3.ui.showLoading();
            const result = await axiosInstance.post('/GetUserInfo', JSON.stringify(params));
            const responseData = typeof result.data === 'string' ? JSON.parse(result.data) : result.data;
            return responseData;
        } catch (err) {
            throw new Error(err);
        } finally {
            e3.ui.hideLoading();
        }
    }
};

export const GetCodes = async (codeID) => {
    let params = DataPackage.create('SYS100', 'getCodes');
    params.KeyValues.push(DataPackage.NewKeyValue('codeId', codeID));
    const result = await ISOAxios.Execute(params);
    if (result) return JSON.parse(result.JsonData);
    return null;
};

export default ISOAxios;
